// ============================================================================
// CATEGORY REDUCER
// ============================================================================
// ./client/src/context/reducers/categoryReducer.js

const categoryReducer = (state, { type, payload }) => {
  switch (type) {
    case 'SET_LOADING':
      return {
        ...state,
        loading: payload
      };

    case 'SET_ERROR':
      return {
        ...state,
        error: payload,
        loading: false
      };

    case 'SET_CATEGORIES':
      return {
        ...state,
        categories: payload,
        loading: false,
        error: null
      };

    case 'SET_CURRENT_CATEGORY':
      return {
        ...state,
        currentCategory: payload,
        loading: false,
        error: null
      };

    case 'SET_PAGINATION':
      return {
        ...state,
        pagination: payload
      };

    case 'ADD_CATEGORY':
      return {
        ...state,
        categories: [...state.categories, payload],
        loading: false,
        error: null
      };

    case 'UPDATE_CATEGORY':
      return {
        ...state,
        categories: state.categories.map(cat =>
          cat.categoryId === payload.categoryId ? payload : cat
        ),
        currentCategory: state.currentCategory?.categoryId === payload.categoryId
          ? payload
          : state.currentCategory,
        loading: false,
        error: null
      };

    case 'DELETE_CATEGORY':
      return {
        ...state,
        categories: state.categories.filter(cat => cat.categoryId !== payload),
        currentCategory: state.currentCategory?.categoryId === payload
          ? null
          : state.currentCategory,
        loading: false,
        error: null
      };

    case 'CLEAR_ERROR':
      return {
        ...state,
        error: null
      };

    case 'CLEAR_CURRENT_CATEGORY':
      return {
        ...state,
        currentCategory: null
      };

    default:
      return state;
  }
};

export default categoryReducer;
